import './App.css';
import React, { useEffect, useState } from "react";
import { LineChart, Line, XAxis, YAxis, Legend } from 'recharts';  // Tooltip

// var selectedCategory = 'NA';
var currentuserid = '';


let paramString = window.location.href.split('?')[1];
if (paramString) {
  let queryString = new URLSearchParams(paramString);
  for (let pair of queryString.entries()) {
    if (pair[0] === 'CategoryName') {
      // selectedCategory = pair[1];
    }
    if (pair[0] === 'userid') {
      currentuserid = pair[1];
      document.getElementById('userid-label').innerText = currentuserid;
    }
  }
}

function MyKnowledgeScore() { 
  const KC_SERVICE = process.env.REACT_APP_KC_SERVICE || 'https://kc-service-eight.vercel.app'; // https://kc-service-eight.vercel.app // http://localhost:3000
  console.log(KC_SERVICE);

  // const [overallScore, setOverallScore] = useState(0);
  const [data, setResponses] = useState([]);

  useEffect(() => {
    async function fetchScore() {
      if (!currentuserid) return;
      // Fetch all responses for current user, including linked question scores
      const response = await fetch(KC_SERVICE + '/userresponses_getAll', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId: currentuserid.split('-')[0] }),
      });
      if (!response.ok) {
        console.error('Failed to fetch data:', response.statusText);
        setResponses([]);
        return;
      }

      const responseData = await response.json();
      // console.log('Fetched data:', response);
      console.log('Fetched data:', responseData);
      console.log('Fetched data:', responseData.UserResponses);


      setResponses(Array.isArray(responseData.UserResponses) ? responseData.UserResponses : []);
    }

    fetchScore();
  }, [KC_SERVICE]);





  // Prepare chart data: group by date, then for each category, fill only where data exists
  const chartDates = Array.from(new Set(Array.isArray(data) ? data.map(row => row.ResponseDateTime ? row.ResponseDateTime.split('T')[0] : '') : [])).sort();
  // Get all categories present in data
  const categories = Array.from(new Set(Array.isArray(data) ? data.map(row => row.Questions?.CategoryTable?.CategoryName || 'Unknown') : []));

  // For each category, build a line data array with only points where that category has a response
  const categoryLineData = {};
  categories.forEach(cat => {
    categoryLineData[cat] = data
      .filter(row => (row.Questions?.CategoryTable?.CategoryName || 'Unknown') === cat)
      .map(row => ({
        ResponseDateTime: row.ResponseDateTime,
        DateOnly: row.ResponseDateTime ? row.ResponseDateTime.split('T')[0] : '',
        Score: row.Questions?.KnowledgeScore || 0,
        QuestionText: row.Questions?.QuestionText || '',
        Category: cat
      }));
  });

  // Calculate highest and average KnowledgeScore per category
  const categoryStats = categories.map(cat => {
    const scores = data
      .filter(row => (row.Questions?.CategoryTable?.CategoryName || 'Unknown') === cat)
      .map(row => row.Questions?.KnowledgeScore || 0);
    const highest = scores.length ? Math.max(...scores) : 0;
    const average = scores.length ? (scores.reduce((a, b) => a + b, 0) / scores.length).toFixed(2) : 0;
    return { category: cat, highest, average };
  });

  return (
    <div>
      <h2>Knowledge Score Over Time</h2>
      <LineChart
        width={800}
        height={400}
        data={[]} // No global data, each Line uses its own data prop
        style={{ background: '#fff' }}
      >
        <XAxis
          dataKey="DateOnly"
          type="category"
          allowDuplicatedCategory={false}
          stroke="#222"
          ticks={chartDates}
        />
        <YAxis dataKey="Score" stroke="#222" />
        {/* <Tooltip
          content={({ active, payload, label }) => {
            if (active && payload && payload.length) {
              const item = payload[0];
              return (
                <div style={{
                  background: '#fff',
                  border: '1px solid #ccc',
                  padding: 10,
                  fontSize: 14,
                  maxWidth: 100,
                  whiteSpace: 'pre-line',
                  zIndex: 1000,
                  pointerEvents: 'auto'
                }}>
                  <div>Date: {label}</div>
                  <div>
                    Score: {item.value}
                    {item.payload.QuestionText ? `, Q: ${item.payload.QuestionText}` : ''}
                  </div>
                </div>
              );
            }
            return null;
          }}
          allowEscapeViewBox={{ x: true, y: true }}
          position={{ y: 20 }}
        /> */}
        <Legend />
        {
          Object.entries(categoryLineData).map(([cat, catData], idx) => (
            <Line
              key={cat}
              type="monotone"
              dataKey="Score"
              name={cat}
              stroke={`hsl(${idx * 60}, 80%, 25%)`}
              dot={{ stroke: '#222', strokeWidth: 2 }}
              isAnimationActive={false}
              connectNulls={false}
              data={catData}
              xAxisId={0}
            />
          ))
        }
        {/* <Tooltip cursor={false} /> */}
      </LineChart>
      <div style={{ marginTop: 30 }}>
        <h3>Category Stats</h3>
        <table style={{ borderCollapse: 'collapse', width: '60%' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Category</th>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Highest Score</th>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Average Score</th>
            </tr>
          </thead>
          <tbody>
            {categoryStats.map(stat => (
              <tr key={stat.category}>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{stat.category}</td>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{stat.highest}</td>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{stat.average}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default MyKnowledgeScore;